import React from "react"
import PropTypes from "prop-types"
import DynamicTag from "components/DynamicTag"

import { useTranslation } from "react-i18next"
import pluralize from "pluralize"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"
import { Button, Flex, Card } from "antd"
import useActiveGuide from "hooks/useActiveClient"

WithEmptyStateWrapper.propTypes = {
  name: PropTypes.string.isRequired,
  tag: PropTypes.string,
  emptyProps: PropTypes.object,
  hasItems: PropTypes.bool,
  children: PropTypes.node,
  fallback: PropTypes.node,
  fallbackTitle: PropTypes.string,
  fallbackImageSrc: PropTypes.string,
  fallbackButtonText: PropTypes.string,
  fallbackButtonClickHandler: PropTypes.func,
  isPending: PropTypes.bool
}

WithEmptyStateWrapper.defaultProps = {
  tag: "div",
  emptyProps: {},
  hasItems: false,
  fallback: null,
  fallbackTitle: undefined,
  fallbackImageSrc: undefined,
  fallbackButtonText: undefined,
  fallbackButtonClickHandler: undefined,
  dynamicClassName: "",
  isPending: false
}

export default function WithEmptyStateWrapper({
  name,
  tag = "div",
  emptyProps = {},
  hasItems = false,
  children,
  fallback,
  fallbackTitle,
  fallbackImageSrc,
  fallbackButtonText,
  dynamicClassName,
  fallbackButtonClickHandler,
  isPending,
  ...rest
}) {
  const { t } = useTranslation()
  const { isActive: active } = useActiveGuide()

  const btnText = fallbackButtonText ?? t("empty_state.btn_text")
  return (
    <DynamicTag {...rest} tag={tag || React.Fragment} className={`flex-1 ${dynamicClassName}`} {...emptyProps}>
      {hasItems
        ? children
        : fallback || (
          <Card className="py-5xl">
            <Flex vertical justify="center" align="center" gap={12}>
              {fallbackImageSrc || null}
              <Text color={colors.textSecondaryDark}>{fallbackTitle ?? t("empty_state.title", { name: pluralize(name) })}</Text>
              {fallbackButtonClickHandler && (
                <Button
                  type="primary"
                  className="px-l"
                  aria-label={btnText}
                  disabled={!active || isPending}
                  onClick={active && !isPending ? fallbackButtonClickHandler : undefined}
                >
                  {btnText}
                </Button>
              )}
            </Flex>
          </Card>
        )}
    </DynamicTag>
  )
}
